import { createSlice } from "@reduxjs/toolkit";

export const glAccountsSlice = createSlice({
  name: "glAccounts",
  initialState: { glAccounts: [], status: "idle", error: null },
  reducers: {
    setGLAccounts: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.glAccounts = action.payload;
      state.status = "ready";
      state.error = null;
    },
    setGLAccountsStatus: (state, action) => {
      state.status = action.payload?.status || "idle";
      state.error = action.payload?.error ?? null;
    },
    clearGLAccounts: (state) => {
      state.glAccounts = [];
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { setGLAccounts, setGLAccountsStatus, clearGLAccounts } =
  glAccountsSlice.actions;

export default glAccountsSlice.reducer;
